// The SummarySection domain enumeration (Domain/Entities/SummarySection.cs). Fixed values rather than
// admin-editable data, so they live here instead of behind a lookup endpoint.
export const SUMMARY_SECTIONS = [
  { id: 1, name: 'Site Labour' },
  { id: 2, name: 'Management' },
];

// A calculation may roll up nowhere, so the rate sheet offers None as well. A labour rate class may
// not — its domain setter rejects None, because Project.RecalculateSummaryTotals and the
// labour-hours summaries filter on Site Labour / Management only.
export const SUMMARY_SECTIONS_WITH_NONE = [{ id: null, name: 'None' }, ...SUMMARY_SECTIONS];
